import React from 'react';
import Tooltip from './Tooltip';
/**
 * Explains a disabled control in a tooltip.
 *
 * @param {IProps} props - The props of the component.
 * @returns {ReactElement}
 */
const DisabledReasonTooltip = ({ children, reason }) => (reason ? React.createElement(Tooltip, { content: reason }, children) : children);
export default DisabledReasonTooltip;
